var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copy-right"},[_vm._v("Copyright©51job.All Rights Reserved.")])
}
var staticRenderFns = []

export { render, staticRenderFns }